import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const IconHeartFilled: React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M12 21a.996.996 0 0 1-.708-.294l-7.767-7.78a5.245 5.245 0 0 1 0-7.399A5.188 5.188 0 0 1 7.22 4c1.399 0 2.712.543 3.695 1.527L12 6.614l1.084-1.086A5.189 5.189 0 0 1 16.78 4c1.399 0 2.712.543 3.695 1.527a5.246 5.246 0 0 1 .001 7.399l-7.768 7.781A1 1 0 0 1 12 21Z"
      fill={props.fill || 'currentColor'}
    />
  </SvgIcon>
);

export default IconHeartFilled;
